import { ContentSearchType } from '@/components/common/Providers/GraphqlProvider/generated';

type Action = 'OPEN' | 'NAVIGATE';

export type SearchCategory = {
  id: ContentSearchType;
  label: string;
  action: Action;
};

export type SearchResult = {
  id: string;
  category: SearchCategory;
  title: string;
  description: string;
  publishDate?: string;
  dependency?: string;
  slug?: string | null;
  href?: string;
};

export { ContentSearchType };
